<template>
  <div id="app" :class="{ pc: formatterPc }">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    formatterPc() {
      const version = window.navigator.appVersion
      return version.includes('Intel Mac OS') || version.includes('Windows')
    }
  }
}
</script>

<style lang="scss">
@import 'assets/css/style.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  height: 100%;
  &.pc {
    height: 667px;

    .tw-xlxq-body-main-body-mid::-webkit-scrollbar {
      display: scroll;
    }
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
